"use strict";

const Cursor = () => {
    const init = () => {
        $(document).ready(function() {
            let $cursor = $('#cursor'),
                $next = $('.cursor-follow-next'),
                $prev = $('.cursor-follow-prev');

            $next.mouseover(function() {
                // Add cursor
                $cursor.addClass('next');
            }).mouseout(function() {
                // Remove cursor
                $cursor.removeClass('next');
            });

            $prev.mouseover(function() {
                // Add cursor
                $cursor.addClass('prev');
            }).mouseout(function() {
                // Remove cursor
                $cursor.removeClass('prev');
            });

            // Track mouse movement
            let $mouseX = 0,
                $mouseY = 0;

            $(document).mousemove(function(e){
                $mouseX = e.pageX;
                $mouseY = e.pageY - window.pageYOffset;
            });
            let $loop = setInterval(function(){
                $cursor.css({
                    left: $mouseX +'px',
                    top: $mouseY +'px'
                });
            }, 30);
        });
    };

    return {
        init:init
    };
};

export default Cursor;